import { Injectable, signal } from '@angular/core';

export type GoogleMapsLoadStatus = 'loading' | 'loaded' | 'error';

/**
 * Tracks whether the Google Maps script (injected by a provideAppInitializer in app.config.ts)
 * actually loaded, so MapViewComponent can wait for a real answer instead of rendering
 * `<google-map>` against a `window.google` that may not exist yet — or may never arrive, on a
 * blocked domain, a dead key, or no outbound network from the browser. Also carries an auth
 * rejection reported later by `<google-map>`'s own `authFailure` output, which only fires once
 * the script has already loaded, so it is a distinct failure from the script never arriving.
 */
@Injectable({ providedIn: 'root' })
export class GoogleMapsLoaderService {
  private readonly _status = signal<GoogleMapsLoadStatus>('loading');
  readonly status = this._status.asReadonly();

  markLoaded(): void {
    this._status.set('loaded');
  }

  markError(): void {
    this._status.set('error');
  }
}
